<template>
  <div class="forms">
    <v-data-table
      :headers="formHeaders"
      :items="formsList"
      item-key="TaskId"
      :loading="this.loading"
      dense
      :items-per-page="-1"
      @click:row="onEditRow"
    >
      <template v-slot:loading>
        <v-skeleton-loader type="table-row@10" />
      </template>

      <template v-slot:top>
        <div class="tableDialog">
          <v-dialog persistent v-model="isDialogShown" max-width="750px">
            <v-card>
              <v-card-title>
                <span>Edit Menu Item</span>
              </v-card-title>

              <v-card-text>
                <div>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        label="Form Name"
                        v-model="editedItem.TaskName"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Menu Name" v-model="editedItem.MenuName"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        type="Number"
                        label="Menu Level"
                        v-model="editedItem.MenuLevel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        type="Number"
                        label="Menu Order"
                        v-model="editedItem.MenuOrder"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        type="Number"
                        label="Sub Order"
                        v-model="editedItem.SubOrder"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Menu Icon" v-model="editedItem.MenuIcon"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-checkbox label="Enabled?" v-model="editedItem.Enabled"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="cancelSave"> Cancel </v-btn>
                <v-btn color="primary" depressed @click="saveItem"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <template v-slot:[`item.Enabled`]="{ item }">
        <v-simple-checkbox v-model="item.Enabled" disabled></v-simple-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'Forms',
  data() {
    return {
      loading: false,
      formsList: [],
      formHeaders: [
        { text: 'Form Name', value: 'TaskName' },
        { text: 'Menu Name', value: 'MenuName' },
        { text: 'Menu Order', value: 'MenuOrder' },
        { text: 'Menu Level', value: 'MenuLevel' },
        { text: 'Sub Order', value: 'SubOrder' },
        { text: 'Enabled?', value: 'Enabled' },
        {text: 'Menu Icon', value: 'MenuIcon'}
      ],
      isDialogShown: false,
      editedItem: {},
    };
  },

  mounted() {
    this.getForms();
  },

  methods: {
    onEditRow(item) {
      this.isDialogShown = true;
      this.editedItem = { ...item };
    },

    cancelSave() {
      this.isDialogShown = false;
      this.editedItem = {};
    },

    async saveItem() {
      this.loading = true;
      try {

        if (this.editedItem.TaskName == 'Security' || this.editedItem.TaskName == "FormEditors" || this.editedItem.TaskName == 'Forms'){
          if (!this.editedItem.Enabled){
            this.$store.commit('setNotificationMessage', { type: 'error', text: `Cannot Remove ${this.editedItem.MenuName} tab.` });
            return;
          }
        }
        let response = await this.$api.post('/AuroraTasks/UpdateMenuItem', this.editedItem);
        if (!response) {
          throw new Error('Empty Response when saving item');
        }
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Menu Item Saved',
        });

        this.getForms();
      } catch (err) {
        console.log(err);
        const msg = 'Error saving Menu Item';
        this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
      } finally {
        this.loading = false;
        this.isDialogShown = false;
      }
    },

    async getForms() {
      try {
        this.loading = true;
        let response = await this.$api.get('/AuroraTasks/GetFormsList');

        if (!response) {
          throw new Error('Empty Response loading forms');
        }

        this.formsList = response.data;
      } catch (err) {
        console.error(err);
        const msg = 'Unable to get form data';
        this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
        throw new Error(msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.tableDialog {
  display: flex;
  align-items: baseline;
  padding-bottom: 4px;
}
</style>
